define((require) => {
    const ImprovedCompositeView     = require("zbone/ImprovedCompositeView");
    const ImageTagItemView          = require("ui/assets/image/tags/ImageTagItemView");

    /**
    *
    * Tag composite view
    *
    * @see ImageTagCollection
    * @see ImageTagModel
    *
    * @class ImageTagCompositeView
    */
    return ImprovedCompositeView.extend({

        className: "tags-composite",

        itemViewContainer: ".tags-list",

        itemView: ImageTagItemView,


        options: {
            editable: false
        },


        _focusInputOnRender: false,

        $formGroup: null,

        $input: null,

        collectionEvents: {
            "sort": "_resortView"
        },

        itemViewOptions() {
            return {
                editable: this.options.editable,
                triggerSource: this
            };
        },

        _tagInputKeydownHandler() {
            this.$formGroup.toggleClass("has-error", false);
        },

        _resortView() {
            this._focusInputOnRender = this.$input.is(":focus");
            this.render();
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/assets/image/TagCompositeView.js